import { render, staticRenderFns } from "./ProgramAdminV3.vue?vue&type=template&id=526a1ae6&scoped=true"
import script from "./ProgramAdminV3.vue?vue&type=script&lang=js"
export * from "./ProgramAdminV3.vue?vue&type=script&lang=js"
import style0 from "./ProgramAdminV3.vue?vue&type=style&index=0&id=526a1ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526a1ae6",
  null
  
)

export default component.exports